import { styled, keyframes } from '@grupoboticario/flora-react';
import ReactSkeleton from 'react-loading-skeleton';

const loadingAnimation = keyframes({
  '100%': {
    transform: 'translateX(100%)',
  },
});

export const styles = {
  Component: styled('div', {
    height: '100%',
    width: '100%',

    '*': {
      height: '100%',
      width: '100%',
    },
  }),

  Skeleton: styled(ReactSkeleton, {
    '--base-color': '$nonInteractiveAltAuxiliar',
    '--animation-duration': '2200ms',
    '--animation-direction': 'normal',
    '--highlight-color': '$backgroundSecondary',
    '--pseudo-element-display': 'block',
    backgroundColor: '$nonInteractiveAltAuxiliar',
    borderRadius: '$small',
    display: 'inline-flex',
    lineHeight: '1',
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    zIndex: '1',

    '&::after': {
      animationDirection: 'var(--animation-direction)',
      animationDuration: 'var(--animation-duration)',
      animationIterationCount: 'infinite',
      animationName: `${loadingAnimation}`,
      animationTimingFunction: `200ms`,
      background: `linear-gradient(
      90deg,
      var(--base-color),
      var(--highlight-color),
      var(--base-color)
    )
    no-repeat`,
      content: '',
      display: 'var(--pseudo-element-display)',
      height: '100%',
      left: 0,
      position: 'absolute',
      right: 0,
      top: 0,
      transform: 'translateX(-100%)',
    },
  }),
};

export default styles;
